import React from "react";
import { t } from "i18next";
import { CustomButton } from "components/Button";
const ConfirmModal = ({ title, onConfirm=()=>{}, onCancel=()=>{} }) => {
  return (
    <div className="w-full items-center justify-center top-0 left-0 h-app-height modal-mask  overflow-y-auto flex">
      <div className="w-full h-fit mx-4 bg-white rounded-16x">
        <form
          className="py-8 px-4 xs:px-8"
          onSubmit={(e) => {
            e.preventDefault();
          }}
        >
          <div className="text-21x font-bold text-center">{title?.title}</div>
          <div className="">
            <p className="mb-6 text-16x text-center">{title?.message}</p>
          </div>
          <div className="grid grid-cols-2 gap-3">
              <CustomButton
                type="button"
                onClick={onCancel}
                outline
                className="w-full capitalize"
                title={t("no")}
                style={{
                  borderRadius: "16px"
                }}
              />
          
              <CustomButton
                  type="button"
                  onClick={onConfirm}
                  title={t("yes")}
                  className="w-full capitalize"
                  style={{
                    borderRadius: "16px"
                  }}
                />
          </div>
        </form>
      </div>
    </div>
  );
};

export default ConfirmModal;
